export default "__VITE_ASSET__Ds2gyjNE__"